import {
    useEffect,
    useState
} from 'react';
import { useDispatch } from 'react-redux';

import { getQuestionFailure } from '../../containers/question-container/store/question-actions';
import { Resources } from '../../resources/resources';
import {
    Nav,
    QuestionSetPayload,
    QuestionVariant
} from './preview.types';

export const useQuestionSet = () => {
    const dispatch = useDispatch();
    const [questionSet, setQuestionSet] = useState<QuestionSetPayload | null>(null);
    const [questions, setQuestions] = useState<QuestionVariant[] | null>(null);

    useEffect(() => {
        if (questionSet) {
            switch (questionSet.questionSetType) {
            case 0: {
                setQuestions([
                    questionSet.sections[0]?.questionVariantIds[0],
                    questionSet.sections[0]?.questionVariantIds[3],
                    questionSet.sections[0]?.questionVariantIds[6],
                    questionSet.sections[0]?.questionVariantIds[9],
                    questionSet.sections[0]?.questionVariantIds[12],
                    questionSet.sections[1]?.questionVariantIds[0],
                    questionSet.sections[1]?.questionVariantIds[3],
                    questionSet.sections[1]?.questionVariantIds[6],
                    questionSet.sections[2]?.questionVariantIds[0],
                    questionSet.sections[2]?.questionVariantIds[3]
                ] ?? null);
                break;
            }
            default: {
                setQuestions(questionSet.sections[0]?.questionVariantIds ?? null);
                break;
            }
            }
        }
    }, [questionSet]);

    const getQuestionSet = async (questionSetId: string, locale: string) => {
        try {
            const response = await Resources.getQuestionSetPreview
                .get({ questionSetId })
                .withParams({ locale })
                .send();

            if (response.data) {
                setQuestionSet(response.data);
            } else {
                dispatch(getQuestionFailure());
            }
        } catch (e) {
            dispatch(getQuestionFailure());
        }
    };

    return {
        questionSet,
        questions,
        getQuestionSet
    };
};

export const useNav = (totalQuestions = 0) => {
    const [questionNumber, setQuestionNum] = useState(0);
    const navigate = (type: number) => {
        if (questionNumber === totalQuestions - 1 && type === Nav.forward) {
            setQuestionNum(0);
        } else if (questionNumber === 0 && type === Nav.backward) {
            setQuestionNum(totalQuestions - 1);
        } else if (type === Nav.forward) {
            setQuestionNum(questionNumber + 1);
        } else if (type === Nav.backward) {
            setQuestionNum(questionNumber - 1);
        }
    };

    return {
        questionNumber,
        navigate
    };
};
